import { jsxs, jsx } from 'react/jsx-runtime';
import React__default from 'react';
import cns from '../../node_modules/classnames/index.js';
import Step from './Step.js';
import StepItem from './StepItem.js';

/**
Gli stepper oltre a dividere una sequenza in diversi passaggi, possono anche essere utilizzati per la navigazione.
Posso anche dare un feedback di un salvataggio parziale.
 */
const Stepper = function Stepper({ children, className = '', etichetteAlternative = false, onClick, nonlinear = false, vertical = false, small = false, spaced = true, }) {
    const stepperGroupClasses = cns('stepper__group', {
        'stepper__group--noSpaced': !spaced,
        'stepper__group--vertical': vertical,
        'stepper__group--small': small,
    }, className);
    const stepperClasses = cns('stepper', {
        'stepper--nonlineare': nonlinear,
        'stepper--etichetteAlternative': etichetteAlternative,
    }, className);
    const myChildren = React__default.Children.toArray(children).filter((child) => child);
    return (jsxs("div", { className: stepperGroupClasses, children: [jsx("div", { className: stepperClasses, children: jsx("div", { className: "stepper__center", children: React__default.Children.map(myChildren, (x, i) => (jsx(StepItem, Object.assign({}, x.props, { index: i + 1, onClick: onClick }), i + 1))) }) }), jsx("div", { className: "stepper__container stepper_container__block", children: jsx("div", { className: "stepper__wrapper", children: jsx("div", { className: "stepper__padder", children: React__default.Children.map(myChildren, (x) => (x.props.state === Step.State.ACTIVE
                            ? jsx("div", { children: (x.props.code || x.props.children) })
                            : jsx("div", {}))) }) }) })] }));
};
Stepper.Step = Step;
Stepper.State = Step.State;

export { Stepper as default };
